import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';

import { getLessonReports } from 'store/lesson-reports/actions';
import { lessonReportsSelector } from 'store/lesson-reports/selectors';

import { usePagination } from 'hooks/usePagination';

import { getTranslation } from 'helpers/getTranslation';

import LessonReports from './LessonReports';

const LessonReportsContainer = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const {
    data: lessonsReports,
    currentPage,
    totalPages,
    perPage,
  } = useAppSelector(lessonReportsSelector);

  const [loading, setLoading] = useState(true);

  const [sortParams, setSortParams] = useState({
    sortBy: {
      label: getTranslation('inbox_page.action.date'),
      value: 'createdAt',
    },
    sortDirection: 'desc',
  });

  useEffect(() => {
    const _getLessonsReports = async () => {
      try {
        await dispatch(
          getLessonReports({
            page: 1,
            limit: perPage,
            sortBy: sortParams.sortBy.value,
            sortDirection: sortParams.sortDirection,
          }),
        ).unwrap();
      } catch (error) {
        console.warn(error);
      }

      setLoading(false);
    };

    _getLessonsReports();
  }, [sortParams]);

  const handleSortChange = (values: any) => {
    setSortParams((prevState: any) => ({
      ...prevState,
      ...values,
    }));
  };

  const [onPerPageChange, onPrevPageClick, onNextPageClick] = usePagination({
    dataAction: getLessonReports,
    currentPage,
    totalPages,
    perPage,
    sortBy: sortParams.sortBy.value,
    sortDirection: sortParams.sortDirection,
  });

  return (
    <LessonReports
      locale={i18n.language}
      loading={loading}
      lessonsReports={lessonsReports}
      onPerPageChange={onPerPageChange}
      onPrevPageClick={onPrevPageClick}
      onNextPageClick={onNextPageClick}
      currentPage={currentPage}
      totalPages={totalPages}
      perPage={perPage}
      sortParams={sortParams}
      onSortChange={handleSortChange}
    />
  );
};

export default React.memo(LessonReportsContainer) as any;
